import type { ItemConfigJson } from './businessVerification';

export interface DueDiligenceDealsResponse {
  data: DueDiligenceDeal[];
}
export interface DueDiligenceDeal {
  dealId: string;
  dealName: string;
}

export interface DueDiligenceTemplate {
  id: string;
  name: string;
  templateType: string;
}

export interface CompanyDetails {
  id: string;
  name: string;
  clientCode: string;
  address: string | null;
  companyHQ: string | null;
}

export interface DueDiligenceTemplateSection {
  id: string;
  items: DueDiligenceTemplateItem[];
  name: string;
  templateType: string;
}

export interface DueDiligenceTemplateItem {
  sectionName: string;
  itemText: string;
  sortOrder: string;
  responseRequired: boolean;
  configJson?: ItemConfigJson | null;
}
export interface CreateDueDiligencePayload {
  clientCode: string;
  templateType: string;
  dueDate: string;
  pocEmails: string[];
  items?: AdditionalInformation[];
}

export interface AdditionalInformation {
  sectionName: string;
  itemText: string;
  sortOrder: string;
  responseRequired: boolean;
}
export enum ChecklistType {
  UNIFIED = 'UNIFIED',
  STANDARD = 'STANDARD',
  REAL_MONEY_GAMING = 'REAL_MONEY_GAMING',
  CHINESE_DEALS = 'CHINESE_DEALS',
}
